import styled from "styled-components";
import { setupWizardActionButtonCss } from "../shared/orderDesign/setupWizardActionStyles";

export const CategoryFilterDiv = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .ant-checkbox-inner {
    border-radius: 2px !important;
  }
  .ant-checkbox-checked {
    .ant-checkbox-inner {
      background-color: #2060ea !important;
      border-color: #2060ea !important;
    }
  }
`;
export const StatusFilterDiv = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  > .ant-radio-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
    font-weight: 400;
    line-height: 22px;

    .ant-radio-inner {
      &::after {
        transform: scale(0.5) !important;
      }
    }
  }
`;
export const FilterSidebarDiv = styled.div`
  width: 230px;
  border-radius: 0 4px 4px 0;
  background-color: var(--Mist, #f7f8f9);
  padding-top: 16px;

  .filterLabel {
    color: var(--Dark-Grey, #262641);
    font-size: 16px;
    font-weight: 500;
    line-height: 150%;
  }
`;

export const SearchInputDiv = styled.div`
  margin: 0 6px;
  height: 32px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #4a4a68;
  border-radius: 4px;
  padding: 5px 16px 5px 8px;

  input {
    background-color: transparent;
    border: none;
    outline: none;
  }
  svg {
    cursor: pointer;
  }
`;

export const ConnectionStatusDiv = styled.div`
  position: absolute;
  right: 0;
  top: 12px;
  padding: 1px 8px;
  border-radius: 4px 0 0 4px;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px; /* 150% */
  letter-spacing: 0.36px;
  &.green {
    background: var(--Green-0, #e1fcef);
    color: var(--Green-500, #14804a);
  }
  &.red {
    background: #ffedef;
    color: var(--Red, #cf324a);
  }
`;

export const IntegrationGridDiv = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  padding: 24px;
  align-content: flex-start;
`;

export const StyledDisabledText = styled.span`
  color: var(--Light-Grey, #8c8ca1);
`;

export const StyledButtonContainerDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 16px 24px 0 24px;
`;

export const StyledRightActionsDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

/** Toolbar cluster — same outline buttons as order detail / integration top bar. */
export const IntegrationToolbarActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  button {
    ${setupWizardActionButtonCss}
  }
`;

/** Relative shell for Sync Now + custom dropdown (TopBar PopupModal pattern). */
export const StyledSyncNowWrap = styled.div`
  position: relative;
  display: inline-flex;
`;

export const StyledSyncMenu = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 11;
  min-width: 200px;
  padding: 6px 0;
  border-radius: 6px;
  border: 1px solid var(--Pearl, #ecf1f4);
  background: #fff;
  box-shadow: 0 8px 24px rgba(16, 36, 77, 0.12);

  > button {
    display: block;
    width: 100%;
    padding: 10px 14px;
    border: none;
    background: transparent;
    color: #323338;
    font-size: 13px;
    font-weight: 500;
    line-height: 20px;
    text-align: left;
    cursor: pointer;

    &:first-child {
      font-weight: 600;
      border-bottom: 1px solid var(--Pearl, #ecf1f4);
      margin-bottom: 4px;
      padding-bottom: 12px;
    }

    &:hover:not(:disabled) {
      background: #f5f8ff;
      color: #1249bf;
    }

    &:disabled {
      color: #8c8ca1;
      cursor: not-allowed;
    }
  }
`;
export const IntegrationCardDiv = styled.div`
  border-radius: 4px;
  border: 1px solid var(--Pearl, #ecf1f4);
  background: #fff;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.05);
  padding: 12px;
  position: relative;
  height: 148px;

  &:hover {
    box-shadow: 0 4px 8px rgba(0 0 0 / 0.12);
    transform: translateY(-1.5px);
    cursor: pointer;
  }

  .cardHeader {
    .headerWithIcon {
      display: flex;
      align-items: center;
      gap: 12px;

      svg {
        width: 40px;
        height: 40px;
      }

      img {
        width: 40px;
        height: 40px;
        object-fit: contain;
      }

      .headerName {
        display: flex;
        flex-direction: column;
        .nameOfHeader {
          color: #000;

          font-family: Inter;
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: 150%;
        }
        .headerType {
          color: #000;

          font-family: Inter;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 150%;
        }
      }
    }
  }

  .description {
    margin-top: 8px;
    color: #000;
    font-size: 12px;
    font-weight: 400;
    line-height: 150%;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines */
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .bottomRight {
    position: absolute;
    bottom: 12px;
    right: 12px;
  }
  .bottomLeft {
    position: absolute;
    bottom: 12px;
    left: 12px;
  }
  .switchStatus {
    color: #1249bf;
    font-family: Inter;
    font-size: 13px;
    font-weight: 600;
    line-height: 20px;
    display: flex;
    gap: 8px;
    align-items: center;
    cursor: default;

    .ant-switch {
      min-width: 36px;
      height: 20px;
      background: #d5deea;
    }

    .ant-switch:hover:not(.ant-switch-disabled) {
      background: #c5d0e0;
    }

    .ant-switch-checked {
      background: #2060ea !important;
    }

    .ant-switch-checked:hover:not(.ant-switch-disabled) {
      background: #1249bf !important;
    }

    .ant-switch-handle::before {
      box-shadow: 0 1px 3px rgba(16, 36, 77, 0.12);
    }
  }
`;
